export default "__VITE_ASSET__b0f69dae__"